/**
 * Created by XuQiang on 2017/5/24.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tabs } from 'antd';
import { OPEN_LOGIN, OPEN_SIGN } from '../../utils/constants';

const TabPane = Tabs.TabPane;
let reSendInterval = null;

export default ({ intl, loginData, dispatch }) => {
  const { register, registerMobile, msm } = loginData;
  let reSend =
    msm.minutes > 60 ? (
      <FormattedMessage id="index_valid_code" />
    ) : (
      intl.formatMessage({ id: 're_send' }) + `(${msm.minutes})`
    );
  if (msm.minutes < 0) {
    window.clearInterval(reSendInterval);
    dispatch({ type: 'login/setMsm', msm: { minutes: 61, validCode: '' } });
  }
  return (
    <div className="fix-activate">
      <div className="activate-cont">
        <div className="activate-title">
          <FormattedMessage id="index_activation" />
        </div>
        <Tabs type="card" animated={false}>
          <TabPane tab={intl.formatMessage({ id: 'index_tip_email' })} key="1">
            <div className="activate-type">
              <input type="mail" defaultValue={register.email} readOnly />
              <a
                onClick={() =>
                  dispatch({ type: 'login/registerDomain', noticeType: 0 })
                }
              >
                <FormattedMessage id="index_send" />
              </a>
            </div>
          </TabPane>
          <TabPane
            tab={intl.formatMessage({ id: 'index_valid_phone' })}
            key="2"
          >
            <div className="activate-type">
              <input
                type="tel"
                readOnly={!register.info}
                value={register.verifyCode || registerMobile}
                onChange={t => {
                  dispatch({
                    type: 'login/setRegister',
                    register: { ...register, verifyCode: t.target.value }
                  });
                }}
                placeholder={
                  register.info
                    ? intl
                        .formatMessage({ id: 'index_domain_msm' })
                        .substring(0, 3)
                    : intl.formatMessage({ id: 're_tel_number' })
                }
              />
              <a
                onClick={() => {
                  dispatch({
                    type: 'login/setMsm',
                    msm: { minutes: 60, validCode: '' }
                  });
                  if (msm.minutes > 0 && msm.minutes <= 61) {
                    reSendInterval = setInterval(() => {
                      dispatch({ type: 'login/updateMsm' });
                    }, 1000);
                  }
                  dispatch({
                    type: 'login/msmValidate',
                    payload: { ...register, flag: 0 }
                  });
                }}
                disabled={msm.minutes < 61}
              >
                {reSend}
              </a>
            </div>
          </TabPane>
        </Tabs>
        <p className="register-case">&nbsp;</p>
        <div className="activate-btn">
          <button
            onClick={() =>
              dispatch({ type: 'login/setDivType', divType: OPEN_SIGN })
            }
          >
            <FormattedMessage id="index_previous" />
          </button>
          <button
            disabled={
              !(register.verifyCode && register.verifyCode.length === 6)
            }
            onClick={() =>
              dispatch({ type: 'login/registerDomain', noticeType: 1 })
            }
          >
            <FormattedMessage id="index_complete" />
          </button>
        </div>
        <div className="jump_link">
          <a
            className="lr"
            onClick={() =>
              dispatch({ type: 'login/setDivType', divType: OPEN_LOGIN })
            }
          >
            <FormattedMessage id="index_login2" />
          </a>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/login/ActivationDiv.js